// A ref-counted body scroll lock shared by every overlay (modal, drawer). Each layer that opens
// takes a lock and releases it on close. The body's original overflow is captured only for the
// first lock and restored only when the last lock is released, so stacked or nested overlays that
// close in any order can never leave the page permanently unscrollable.

let lockCount = 0
let previousOverflow = ''

export function lockBodyScroll(): void {
  if (lockCount === 0) {
    previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
  }
  lockCount += 1
}

export function unlockBodyScroll(): void {
  if (lockCount === 0) return
  lockCount -= 1
  if (lockCount === 0) {
    document.body.style.overflow = previousOverflow
  }
}
